import React, { useState, useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap';
import styled from "styled-components";
import Cancel from '../../assets/cross.svg';
import Loader from '../../assets/loading.gif';
import { isEmpty } from '../CommonComponents/helper';
import { Helmet } from "react-helmet";
import "./Modals.css";
import secureLocalStorage from "react-secure-storage";

export default function SendEmailModal(props) {

  let defaultEmail = '';

  if (typeof window !== 'undefined') { 
    try {
      let client = JSON.parse(secureLocalStorage.getItem('client_data'));
      defaultEmail = client?.email || '';
    } catch (e) {
      defaultEmail = '';
    }
  }

  const [emails, setEmails] = useState('');
  const [subject, setSubject] = useState(`${defaultEmail} has sent you a ProDocs document!`);
  const [message, setMessage] = useState('');
  const [localError, setLocalError] = useState('');

  // Clear error on mount / when modal opens
  useEffect(() => {
    if (props.setError) {
      props.setError('');
    }
    setLocalError('');
  }, []);

  const currentError = props.error || localError;

  const validateDynamic = (newEmails, newSubject, newMessage) => {
    if (!currentError) return;

    if (isEmpty(newEmails) || isEmpty(newSubject) || isEmpty(newMessage)) {
      const err = 'Fields with * are required';
      setLocalError(err);
      if (props.setError) props.setError(err);
      return;
    }

    const toEmails = newEmails.split(',');
    let validEmail = true;
    for (const email of toEmails) {
      if (email.trim() && !(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email.trim()))) {
        validEmail = false;
        break;
      }
    }

    if (!validEmail) {
      const err = 'Invalid Email address';
      setLocalError(err);
      if (props.setError) props.setError(err);
      return;
    }

    // All clear - remove error dynamically
    setLocalError('');
    if (props.setError) props.setError('');
  };

  const handleEmails = (value) => {
    setEmails(value);
    validateDynamic(value, subject, message);
  };

  const handleSubject = (value) => {
    setSubject(value);
    validateDynamic(emails, value, message);
  };

  const handleMessage = (value) => {
    setMessage(value);
    validateDynamic(emails, subject, value);
  };

  const handleClose = () => {
    if (props.setError) props.setError('');
    setLocalError('');
    props.setModalShow(false);
  };

  const handleSend = () => {
    if (isEmpty(emails) || isEmpty(subject) || isEmpty(message)) {
      const err = 'Fields with * are required';
      setLocalError(err);
      if (props.setError) props.setError(err);
      return;
    }

    const toEmails = emails.split(',');
    let validEmail = true;
    for (const email of toEmails) {
      if (!(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email.trim()))) {
        validEmail = false;
        break;
      }
    }

    if (!validEmail) {
      const err = 'Invalid Email address';
      setLocalError(err);
      if (props.setError) props.setError(err);
      return;
    }

    setLocalError('');
    if (props.setError) props.setError('');
    props.onSendDoc(emails, subject, message, props.pdfUrl, props.docName);
  };

  const isPdfLoading = isEmpty(props.pdfUrl);

  const isEmailsError = currentError && isEmpty(emails);
  const isSubjectError = currentError && isEmpty(subject);
  const isMessageError = currentError && isEmpty(message);

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <title>Prodocs</title>
      </Helmet>
      <Modal
        {...props}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ opacity: '1' }}
      >
        <Modal.Header className='pb-0'>
          <img onClick={handleClose} src={Cancel} alt="Close" style={{ width: "26px", position: 'absolute', right: '1.5rem', top: '1.5rem', backgroundColor: 'transparent', cursor: 'pointer', border: 'none' }} />
          <Modal.Title id="contained-modal-title-vcenter">
            <p className="modal-title-x mb-0 mt-5 pb-0">Email To...</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          {currentError && (
            <div className="alert alert-danger" role="alert">
              <strong>Error!</strong> {currentError}
            </div>
          )}
          {isPdfLoading ? (
            <LoadingWrapper>
              <img className="loader" src={Loader} alt="Loading document" />
              <p className="mb-0 mt-3 text-center">Please wait while we fetch document.</p>
            </LoadingWrapper>
          ) : (
            <>
              <p>Add a comma separated list recipient emails to send the PDF document. We will send the generated PDF document to each recipient with your customized subject line and message below.<br /><br /></p>
              <p className="mt-3 my-2">Email Recipients <span style={{ color: "#dc3545" }}>*</span></p>
              <InputWrapper className={isEmailsError ? 'has-error' : ''}>
                <input
                  name={"emails"}
                  placeholder="joe@email.com,kyle@email.com,helen@email.com"
                  className={`input-field ${isEmailsError ? 'is-invalid-border' : ''}`}
                  value={emails}
                  onChange={(e) => handleEmails(e.target.value)}
                />
              </InputWrapper>
              <p className="mt-3 my-2">Email Subject Line <span style={{ color: "#dc3545" }}>*</span></p>
              <InputWrapper className={isSubjectError ? 'has-error' : ''}>
                <input
                  name={"subject"}
                  placeholder="Hey John, here is your invoice!"
                  className={`input-field ${isSubjectError ? 'is-invalid-border' : ''}`}
                  value={subject}
                  onChange={(e) => handleSubject(e.target.value)}
                />
              </InputWrapper>
              <p className="mt-3 my-2">Email Message <span style={{ color: "#dc3545" }}>*</span></p>
              <InputWrapper className={isMessageError ? 'has-error' : ''}>
                <textarea
                  type="text"
                  name={"message"}
                  placeholder="Enter a customized email message..."
                  className={`input-field ${isMessageError ? 'is-invalid-border' : ''}`}
                  value={message}
                  onChange={(e) => handleMessage(e.target.value)}
                />
              </InputWrapper>
            </>
          )}
        </Modal.Body>
        <Modal.Footer style={{ paddingBottom: '35px' }}>
          {!isPdfLoading && (
            props.docSend ? <Button className="modal-btn-x" disabled>Sending...</Button> :
              <Button className="modal-btn-x" onClick={handleSend}>Send Document</Button>
          )}
          <Button className="modal-btn-x" onClick={handleClose}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

const InputWrapper = styled.div`
  .input-field {
    width: 100%;
    border-color: hsl(0,0%,80%);
    border-radius: 4px;
    border-style: solid;
    border-width: 1px; 
    color: #212e33;
    font-style: normal;
    min-height: 38px;
    padding: 10px 8px;
    transition: border-color 0.2s ease-in-out;
  }
  .input-field.is-invalid-border {
    border-color: #dc3545 !important;
  }
`;

const LoadingWrapper = styled.div`
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

  
